<script>
  import Button from '@components/buttons/button.svelte'

  let { ...buttonProps } = $props()
</script>

<Button type="submit" variant="primary" text="Submit" {...buttonProps} />